import mixpanel from "mixpanel-browser";
import { useCallback } from "react";

/**
 * Hook for setting Mixpanel People properties in the Promotion project.
 * This is for anonymous user property tracking without identification.
 */
export default function useMixpanelPromotionPeople() {
  const setPeople = useCallback((properties: { [key: string]: any }) => {
    try {
      console.log(
        "[mixpanel promotion people] Setting properties:",
        properties
      );

      // Access promotion instance
      const promotionInstance = (mixpanel as any).promotion;

      if (!promotionInstance) {
        console.error("Mixpanel promotion instance not found!");
        return;
      }

      if (!promotionInstance.people) {
        console.error("Promotion instance.people not found!");
        return;
      }

      // Then set people properties with callback to confirm
      promotionInstance.people.set(properties, (response: any) => {
        if (response === 1 || response?.status === 1) {
        } else {
          console.error(
            "Failed to send people properties. Response:",
            response
          );
        }
      });
    } catch (error) {
      console.error("Error setting mixpanel people properties:", error);
    }
  }, []);

  return setPeople;
}
